/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as SportsRouteImport } from './routes/sports'
import { Route as QaSeedRouteImport } from './routes/qa-seed'
import { Route as PrizeTierDefaultsRouteImport } from './routes/prize-tier-defaults'
import { Route as OperationsRouteImport } from './routes/operations'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ContestsRouteImport } from './routes/contests'
import { Route as ConfigurationRouteImport } from './routes/configuration'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as CatalogueRouteImport } from './routes/catalogue'
import { Route as AssetsRouteImport } from './routes/assets'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users.index'
import { Route as SportsIndexRouteImport } from './routes/sports.index'
import { Route as PrizeTierDefaultsIndexRouteImport } from './routes/prize-tier-defaults.index'
import { Route as ContestsIndexRouteImport } from './routes/contests.index'
import { Route as ConfigurationIndexRouteImport } from './routes/configuration.index'
import { Route as SportsNewRouteImport } from './routes/sports.new'
import { Route as PrizeTierDefaultsNewRouteImport } from './routes/prize-tier-defaults.new'
import { Route as ContestsNewRouteImport } from './routes/contests.new'
import { Route as ContestsIdRouteImport } from './routes/contests.$id'
import { Route as ContestsIdIndexRouteImport } from './routes/contests.$id.index'
import { Route as SportsIdEditRouteImport } from './routes/sports.$id.edit'
import { Route as PrizeTierDefaultsIdEditRouteImport } from './routes/prize-tier-defaults.$id.edit'
import { Route as ContestsIdEditRouteImport } from './routes/contests.$id.edit'
import { Route as ConfigurationKeyEditRouteImport } from './routes/configuration.$key.edit'
import { Route as ContestsIdEditIndexRouteImport } from './routes/contests.$id.edit.index'
import { Route as ContestsIdEntriesEntryIdRouteImport } from './routes/contests.$id.entries.$entryId'
import { Route as ContestsIdEditReelsRouteImport } from './routes/contests.$id.edit.reels'
import { Route as ContestsIdEditPrizesRouteImport } from './routes/contests.$id.edit.prizes'
import { Route as ContestsIdEditLobbyImagesRouteImport } from './routes/contests.$id.edit.lobby-images'
import { Route as ContestsIdEditFixturesRouteImport } from './routes/contests.$id.edit.fixtures'
import { Route as ContestsIdEditBasicRouteImport } from './routes/contests.$id.edit.basic'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const SportsRoute = SportsRouteImport.update({
  id: '/sports',
  path: '/sports',
  getParentRoute: () => rootRouteImport,
} as any)
const QaSeedRoute = QaSeedRouteImport.update({
  id: '/qa-seed',
  path: '/qa-seed',
  getParentRoute: () => rootRouteImport,
} as any)
const PrizeTierDefaultsRoute = PrizeTierDefaultsRouteImport.update({
  id: '/prize-tier-defaults',
  path: '/prize-tier-defaults',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsRoute = OperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ContestsRoute = ContestsRouteImport.update({
  id: '/contests',
  path: '/contests',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationRoute = ConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogueRoute = CatalogueRouteImport.update({
  id: '/catalogue',
  path: '/catalogue',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsRoute = AssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UsersRoute,
} as any)
const SportsIndexRoute = SportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SportsRoute,
} as any)
const PrizeTierDefaultsIndexRoute = PrizeTierDefaultsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrizeTierDefaultsRoute,
} as any)
const ContestsIndexRoute = ContestsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContestsRoute,
} as any)
const ConfigurationIndexRoute = ConfigurationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConfigurationRoute,
} as any)
const SportsNewRoute = SportsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SportsRoute,
} as any)
const PrizeTierDefaultsNewRoute = PrizeTierDefaultsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => PrizeTierDefaultsRoute,
} as any)
const ContestsNewRoute = ContestsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ContestsRoute,
} as any)
const ContestsIdRoute = ContestsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ContestsRoute,
} as any)
const ContestsIdIndexRoute = ContestsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContestsIdRoute,
} as any)
const SportsIdEditRoute = SportsIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => SportsRoute,
} as any)
const PrizeTierDefaultsIdEditRoute = PrizeTierDefaultsIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => PrizeTierDefaultsRoute,
} as any)
const ContestsIdEditRoute = ContestsIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ContestsIdRoute,
} as any)
const ConfigurationKeyEditRoute = ConfigurationKeyEditRouteImport.update({
  id: '/$key/edit',
  path: '/$key/edit',
  getParentRoute: () => ConfigurationRoute,
} as any)
const ContestsIdEditIndexRoute = ContestsIdEditIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContestsIdEditRoute,
} as any)
const ContestsIdEntriesEntryIdRoute =
  ContestsIdEntriesEntryIdRouteImport.update({
    id: '/entries/$entryId',
    path: '/entries/$entryId',
    getParentRoute: () => ContestsIdRoute,
  } as any)
const ContestsIdEditReelsRoute = ContestsIdEditReelsRouteImport.update({
  id: '/reels',
  path: '/reels',
  getParentRoute: () => ContestsIdEditRoute,
} as any)
const ContestsIdEditPrizesRoute = ContestsIdEditPrizesRouteImport.update({
  id: '/prizes',
  path: '/prizes',
  getParentRoute: () => ContestsIdEditRoute,
} as any)
const ContestsIdEditLobbyImagesRoute =
  ContestsIdEditLobbyImagesRouteImport.update({
    id: '/lobby-images',
    path: '/lobby-images',
    getParentRoute: () => ContestsIdEditRoute,
  } as any)
const ContestsIdEditFixturesRoute = ContestsIdEditFixturesRouteImport.update({
  id: '/fixtures',
  path: '/fixtures',
  getParentRoute: () => ContestsIdEditRoute,
} as any)
const ContestsIdEditBasicRoute = ContestsIdEditBasicRouteImport.update({
  id: '/basic',
  path: '/basic',
  getParentRoute: () => ContestsIdEditRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/assets': typeof AssetsRoute
  '/catalogue': typeof CatalogueRoute
  '/change-password': typeof ChangePasswordRoute
  '/configuration': typeof ConfigurationRouteWithChildren
  '/contests': typeof ContestsRouteWithChildren
  '/login': typeof LoginRoute
  '/operations': typeof OperationsRoute
  '/prize-tier-defaults': typeof PrizeTierDefaultsRouteWithChildren
  '/qa-seed': typeof QaSeedRoute
  '/sports': typeof SportsRouteWithChildren
  '/users': typeof UsersRouteWithChildren
  '/contests/$id': typeof ContestsIdRouteWithChildren
  '/contests/new': typeof ContestsNewRoute
  '/prize-tier-defaults/new': typeof PrizeTierDefaultsNewRoute
  '/sports/new': typeof SportsNewRoute
  '/configuration/': typeof ConfigurationIndexRoute
  '/contests/': typeof ContestsIndexRoute
  '/prize-tier-defaults/': typeof PrizeTierDefaultsIndexRoute
  '/sports/': typeof SportsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/configuration/$key/edit': typeof ConfigurationKeyEditRoute
  '/contests/$id/edit': typeof ContestsIdEditRouteWithChildren
  '/prize-tier-defaults/$id/edit': typeof PrizeTierDefaultsIdEditRoute
  '/sports/$id/edit': typeof SportsIdEditRoute
  '/contests/$id/': typeof ContestsIdIndexRoute
  '/contests/$id/edit/basic': typeof ContestsIdEditBasicRoute
  '/contests/$id/edit/fixtures': typeof ContestsIdEditFixturesRoute
  '/contests/$id/edit/lobby-images': typeof ContestsIdEditLobbyImagesRoute
  '/contests/$id/edit/prizes': typeof ContestsIdEditPrizesRoute
  '/contests/$id/edit/reels': typeof ContestsIdEditReelsRoute
  '/contests/$id/entries/$entryId': typeof ContestsIdEntriesEntryIdRoute
  '/contests/$id/edit/': typeof ContestsIdEditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/assets': typeof AssetsRoute
  '/catalogue': typeof CatalogueRoute
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/operations': typeof OperationsRoute
  '/qa-seed': typeof QaSeedRoute
  '/contests/new': typeof ContestsNewRoute
  '/prize-tier-defaults/new': typeof PrizeTierDefaultsNewRoute
  '/sports/new': typeof SportsNewRoute
  '/configuration': typeof ConfigurationIndexRoute
  '/contests': typeof ContestsIndexRoute
  '/prize-tier-defaults': typeof PrizeTierDefaultsIndexRoute
  '/sports': typeof SportsIndexRoute
  '/users': typeof UsersIndexRoute
  '/configuration/$key/edit': typeof ConfigurationKeyEditRoute
  '/prize-tier-defaults/$id/edit': typeof PrizeTierDefaultsIdEditRoute
  '/sports/$id/edit': typeof SportsIdEditRoute
  '/contests/$id': typeof ContestsIdIndexRoute
  '/contests/$id/edit/basic': typeof ContestsIdEditBasicRoute
  '/contests/$id/edit/fixtures': typeof ContestsIdEditFixturesRoute
  '/contests/$id/edit/lobby-images': typeof ContestsIdEditLobbyImagesRoute
  '/contests/$id/edit/prizes': typeof ContestsIdEditPrizesRoute
  '/contests/$id/edit/reels': typeof ContestsIdEditReelsRoute
  '/contests/$id/entries/$entryId': typeof ContestsIdEntriesEntryIdRoute
  '/contests/$id/edit': typeof ContestsIdEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/assets': typeof AssetsRoute
  '/catalogue': typeof CatalogueRoute
  '/change-password': typeof ChangePasswordRoute
  '/configuration': typeof ConfigurationRouteWithChildren
  '/contests': typeof ContestsRouteWithChildren
  '/login': typeof LoginRoute
  '/operations': typeof OperationsRoute
  '/prize-tier-defaults': typeof PrizeTierDefaultsRouteWithChildren
  '/qa-seed': typeof QaSeedRoute
  '/sports': typeof SportsRouteWithChildren
  '/users': typeof UsersRouteWithChildren
  '/contests/$id': typeof ContestsIdRouteWithChildren
  '/contests/new': typeof ContestsNewRoute
  '/prize-tier-defaults/new': typeof PrizeTierDefaultsNewRoute
  '/sports/new': typeof SportsNewRoute
  '/configuration/': typeof ConfigurationIndexRoute
  '/contests/': typeof ContestsIndexRoute
  '/prize-tier-defaults/': typeof PrizeTierDefaultsIndexRoute
  '/sports/': typeof SportsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/configuration/$key/edit': typeof ConfigurationKeyEditRoute
  '/contests/$id/edit': typeof ContestsIdEditRouteWithChildren
  '/prize-tier-defaults/$id/edit': typeof PrizeTierDefaultsIdEditRoute
  '/sports/$id/edit': typeof SportsIdEditRoute
  '/contests/$id/': typeof ContestsIdIndexRoute
  '/contests/$id/edit/basic': typeof ContestsIdEditBasicRoute
  '/contests/$id/edit/fixtures': typeof ContestsIdEditFixturesRoute
  '/contests/$id/edit/lobby-images': typeof ContestsIdEditLobbyImagesRoute
  '/contests/$id/edit/prizes': typeof ContestsIdEditPrizesRoute
  '/contests/$id/edit/reels': typeof ContestsIdEditReelsRoute
  '/contests/$id/entries/$entryId': typeof ContestsIdEntriesEntryIdRoute
  '/contests/$id/edit/': typeof ContestsIdEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/assets'
    | '/catalogue'
    | '/change-password'
    | '/configuration'
    | '/contests'
    | '/login'
    | '/operations'
    | '/prize-tier-defaults'
    | '/qa-seed'
    | '/sports'
    | '/users'
    | '/contests/$id'
    | '/contests/new'
    | '/prize-tier-defaults/new'
    | '/sports/new'
    | '/configuration/'
    | '/contests/'
    | '/prize-tier-defaults/'
    | '/sports/'
    | '/users/'
    | '/configuration/$key/edit'
    | '/contests/$id/edit'
    | '/prize-tier-defaults/$id/edit'
    | '/sports/$id/edit'
    | '/contests/$id/'
    | '/contests/$id/edit/basic'
    | '/contests/$id/edit/fixtures'
    | '/contests/$id/edit/lobby-images'
    | '/contests/$id/edit/prizes'
    | '/contests/$id/edit/reels'
    | '/contests/$id/entries/$entryId'
    | '/contests/$id/edit/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/assets'
    | '/catalogue'
    | '/change-password'
    | '/login'
    | '/operations'
    | '/qa-seed'
    | '/contests/new'
    | '/prize-tier-defaults/new'
    | '/sports/new'
    | '/configuration'
    | '/contests'
    | '/prize-tier-defaults'
    | '/sports'
    | '/users'
    | '/configuration/$key/edit'
    | '/prize-tier-defaults/$id/edit'
    | '/sports/$id/edit'
    | '/contests/$id'
    | '/contests/$id/edit/basic'
    | '/contests/$id/edit/fixtures'
    | '/contests/$id/edit/lobby-images'
    | '/contests/$id/edit/prizes'
    | '/contests/$id/edit/reels'
    | '/contests/$id/entries/$entryId'
    | '/contests/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/assets'
    | '/catalogue'
    | '/change-password'
    | '/configuration'
    | '/contests'
    | '/login'
    | '/operations'
    | '/prize-tier-defaults'
    | '/qa-seed'
    | '/sports'
    | '/users'
    | '/contests/$id'
    | '/contests/new'
    | '/prize-tier-defaults/new'
    | '/sports/new'
    | '/configuration/'
    | '/contests/'
    | '/prize-tier-defaults/'
    | '/sports/'
    | '/users/'
    | '/configuration/$key/edit'
    | '/contests/$id/edit'
    | '/prize-tier-defaults/$id/edit'
    | '/sports/$id/edit'
    | '/contests/$id/'
    | '/contests/$id/edit/basic'
    | '/contests/$id/edit/fixtures'
    | '/contests/$id/edit/lobby-images'
    | '/contests/$id/edit/prizes'
    | '/contests/$id/edit/reels'
    | '/contests/$id/entries/$entryId'
    | '/contests/$id/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AssetsRoute: typeof AssetsRoute
  CatalogueRoute: typeof CatalogueRoute
  ChangePasswordRoute: typeof ChangePasswordRoute
  ConfigurationRoute: typeof ConfigurationRouteWithChildren
  ContestsRoute: typeof ContestsRouteWithChildren
  LoginRoute: typeof LoginRoute
  OperationsRoute: typeof OperationsRoute
  PrizeTierDefaultsRoute: typeof PrizeTierDefaultsRouteWithChildren
  QaSeedRoute: typeof QaSeedRoute
  SportsRoute: typeof SportsRouteWithChildren
  UsersRoute: typeof UsersRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sports': {
      id: '/sports'
      path: '/sports'
      fullPath: '/sports'
      preLoaderRoute: typeof SportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qa-seed': {
      id: '/qa-seed'
      path: '/qa-seed'
      fullPath: '/qa-seed'
      preLoaderRoute: typeof QaSeedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prize-tier-defaults': {
      id: '/prize-tier-defaults'
      path: '/prize-tier-defaults'
      fullPath: '/prize-tier-defaults'
      preLoaderRoute: typeof PrizeTierDefaultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations': {
      id: '/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof OperationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contests': {
      id: '/contests'
      path: '/contests'
      fullPath: '/contests'
      preLoaderRoute: typeof ContestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration': {
      id: '/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof ConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue': {
      id: '/catalogue'
      path: '/catalogue'
      fullPath: '/catalogue'
      preLoaderRoute: typeof CatalogueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets': {
      id: '/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AssetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof UsersRoute
    }
    '/sports/': {
      id: '/sports/'
      path: '/'
      fullPath: '/sports/'
      preLoaderRoute: typeof SportsIndexRouteImport
      parentRoute: typeof SportsRoute
    }
    '/prize-tier-defaults/': {
      id: '/prize-tier-defaults/'
      path: '/'
      fullPath: '/prize-tier-defaults/'
      preLoaderRoute: typeof PrizeTierDefaultsIndexRouteImport
      parentRoute: typeof PrizeTierDefaultsRoute
    }
    '/contests/': {
      id: '/contests/'
      path: '/'
      fullPath: '/contests/'
      preLoaderRoute: typeof ContestsIndexRouteImport
      parentRoute: typeof ContestsRoute
    }
    '/configuration/': {
      id: '/configuration/'
      path: '/'
      fullPath: '/configuration/'
      preLoaderRoute: typeof ConfigurationIndexRouteImport
      parentRoute: typeof ConfigurationRoute
    }
    '/sports/new': {
      id: '/sports/new'
      path: '/new'
      fullPath: '/sports/new'
      preLoaderRoute: typeof SportsNewRouteImport
      parentRoute: typeof SportsRoute
    }
    '/prize-tier-defaults/new': {
      id: '/prize-tier-defaults/new'
      path: '/new'
      fullPath: '/prize-tier-defaults/new'
      preLoaderRoute: typeof PrizeTierDefaultsNewRouteImport
      parentRoute: typeof PrizeTierDefaultsRoute
    }
    '/contests/new': {
      id: '/contests/new'
      path: '/new'
      fullPath: '/contests/new'
      preLoaderRoute: typeof ContestsNewRouteImport
      parentRoute: typeof ContestsRoute
    }
    '/contests/$id': {
      id: '/contests/$id'
      path: '/$id'
      fullPath: '/contests/$id'
      preLoaderRoute: typeof ContestsIdRouteImport
      parentRoute: typeof ContestsRoute
    }
    '/contests/$id/': {
      id: '/contests/$id/'
      path: '/'
      fullPath: '/contests/$id/'
      preLoaderRoute: typeof ContestsIdIndexRouteImport
      parentRoute: typeof ContestsIdRoute
    }
    '/sports/$id/edit': {
      id: '/sports/$id/edit'
      path: '/$id/edit'
      fullPath: '/sports/$id/edit'
      preLoaderRoute: typeof SportsIdEditRouteImport
      parentRoute: typeof SportsRoute
    }
    '/prize-tier-defaults/$id/edit': {
      id: '/prize-tier-defaults/$id/edit'
      path: '/$id/edit'
      fullPath: '/prize-tier-defaults/$id/edit'
      preLoaderRoute: typeof PrizeTierDefaultsIdEditRouteImport
      parentRoute: typeof PrizeTierDefaultsRoute
    }
    '/contests/$id/edit': {
      id: '/contests/$id/edit'
      path: '/edit'
      fullPath: '/contests/$id/edit'
      preLoaderRoute: typeof ContestsIdEditRouteImport
      parentRoute: typeof ContestsIdRoute
    }
    '/configuration/$key/edit': {
      id: '/configuration/$key/edit'
      path: '/$key/edit'
      fullPath: '/configuration/$key/edit'
      preLoaderRoute: typeof ConfigurationKeyEditRouteImport
      parentRoute: typeof ConfigurationRoute
    }
    '/contests/$id/edit/': {
      id: '/contests/$id/edit/'
      path: '/'
      fullPath: '/contests/$id/edit/'
      preLoaderRoute: typeof ContestsIdEditIndexRouteImport
      parentRoute: typeof ContestsIdEditRoute
    }
    '/contests/$id/entries/$entryId': {
      id: '/contests/$id/entries/$entryId'
      path: '/entries/$entryId'
      fullPath: '/contests/$id/entries/$entryId'
      preLoaderRoute: typeof ContestsIdEntriesEntryIdRouteImport
      parentRoute: typeof ContestsIdRoute
    }
    '/contests/$id/edit/reels': {
      id: '/contests/$id/edit/reels'
      path: '/reels'
      fullPath: '/contests/$id/edit/reels'
      preLoaderRoute: typeof ContestsIdEditReelsRouteImport
      parentRoute: typeof ContestsIdEditRoute
    }
    '/contests/$id/edit/prizes': {
      id: '/contests/$id/edit/prizes'
      path: '/prizes'
      fullPath: '/contests/$id/edit/prizes'
      preLoaderRoute: typeof ContestsIdEditPrizesRouteImport
      parentRoute: typeof ContestsIdEditRoute
    }
    '/contests/$id/edit/lobby-images': {
      id: '/contests/$id/edit/lobby-images'
      path: '/lobby-images'
      fullPath: '/contests/$id/edit/lobby-images'
      preLoaderRoute: typeof ContestsIdEditLobbyImagesRouteImport
      parentRoute: typeof ContestsIdEditRoute
    }
    '/contests/$id/edit/fixtures': {
      id: '/contests/$id/edit/fixtures'
      path: '/fixtures'
      fullPath: '/contests/$id/edit/fixtures'
      preLoaderRoute: typeof ContestsIdEditFixturesRouteImport
      parentRoute: typeof ContestsIdEditRoute
    }
    '/contests/$id/edit/basic': {
      id: '/contests/$id/edit/basic'
      path: '/basic'
      fullPath: '/contests/$id/edit/basic'
      preLoaderRoute: typeof ContestsIdEditBasicRouteImport
      parentRoute: typeof ContestsIdEditRoute
    }
  }
}

interface ConfigurationRouteChildren {
  ConfigurationIndexRoute: typeof ConfigurationIndexRoute
  ConfigurationKeyEditRoute: typeof ConfigurationKeyEditRoute
}

const ConfigurationRouteChildren: ConfigurationRouteChildren = {
  ConfigurationIndexRoute: ConfigurationIndexRoute,
  ConfigurationKeyEditRoute: ConfigurationKeyEditRoute,
}

const ConfigurationRouteWithChildren = ConfigurationRoute._addFileChildren(
  ConfigurationRouteChildren,
)

interface ContestsIdEditRouteChildren {
  ContestsIdEditBasicRoute: typeof ContestsIdEditBasicRoute
  ContestsIdEditFixturesRoute: typeof ContestsIdEditFixturesRoute
  ContestsIdEditLobbyImagesRoute: typeof ContestsIdEditLobbyImagesRoute
  ContestsIdEditPrizesRoute: typeof ContestsIdEditPrizesRoute
  ContestsIdEditReelsRoute: typeof ContestsIdEditReelsRoute
  ContestsIdEditIndexRoute: typeof ContestsIdEditIndexRoute
}

const ContestsIdEditRouteChildren: ContestsIdEditRouteChildren = {
  ContestsIdEditBasicRoute: ContestsIdEditBasicRoute,
  ContestsIdEditFixturesRoute: ContestsIdEditFixturesRoute,
  ContestsIdEditLobbyImagesRoute: ContestsIdEditLobbyImagesRoute,
  ContestsIdEditPrizesRoute: ContestsIdEditPrizesRoute,
  ContestsIdEditReelsRoute: ContestsIdEditReelsRoute,
  ContestsIdEditIndexRoute: ContestsIdEditIndexRoute,
}

const ContestsIdEditRouteWithChildren = ContestsIdEditRoute._addFileChildren(
  ContestsIdEditRouteChildren,
)

interface ContestsIdRouteChildren {
  ContestsIdEditRoute: typeof ContestsIdEditRouteWithChildren
  ContestsIdIndexRoute: typeof ContestsIdIndexRoute
  ContestsIdEntriesEntryIdRoute: typeof ContestsIdEntriesEntryIdRoute
}

const ContestsIdRouteChildren: ContestsIdRouteChildren = {
  ContestsIdEditRoute: ContestsIdEditRouteWithChildren,
  ContestsIdIndexRoute: ContestsIdIndexRoute,
  ContestsIdEntriesEntryIdRoute: ContestsIdEntriesEntryIdRoute,
}

const ContestsIdRouteWithChildren = ContestsIdRoute._addFileChildren(
  ContestsIdRouteChildren,
)

interface ContestsRouteChildren {
  ContestsIdRoute: typeof ContestsIdRouteWithChildren
  ContestsNewRoute: typeof ContestsNewRoute
  ContestsIndexRoute: typeof ContestsIndexRoute
}

const ContestsRouteChildren: ContestsRouteChildren = {
  ContestsIdRoute: ContestsIdRouteWithChildren,
  ContestsNewRoute: ContestsNewRoute,
  ContestsIndexRoute: ContestsIndexRoute,
}

const ContestsRouteWithChildren = ContestsRoute._addFileChildren(
  ContestsRouteChildren,
)

interface PrizeTierDefaultsRouteChildren {
  PrizeTierDefaultsNewRoute: typeof PrizeTierDefaultsNewRoute
  PrizeTierDefaultsIndexRoute: typeof PrizeTierDefaultsIndexRoute
  PrizeTierDefaultsIdEditRoute: typeof PrizeTierDefaultsIdEditRoute
}

const PrizeTierDefaultsRouteChildren: PrizeTierDefaultsRouteChildren = {
  PrizeTierDefaultsNewRoute: PrizeTierDefaultsNewRoute,
  PrizeTierDefaultsIndexRoute: PrizeTierDefaultsIndexRoute,
  PrizeTierDefaultsIdEditRoute: PrizeTierDefaultsIdEditRoute,
}

const PrizeTierDefaultsRouteWithChildren =
  PrizeTierDefaultsRoute._addFileChildren(PrizeTierDefaultsRouteChildren)

interface SportsRouteChildren {
  SportsNewRoute: typeof SportsNewRoute
  SportsIndexRoute: typeof SportsIndexRoute
  SportsIdEditRoute: typeof SportsIdEditRoute
}

const SportsRouteChildren: SportsRouteChildren = {
  SportsNewRoute: SportsNewRoute,
  SportsIndexRoute: SportsIndexRoute,
  SportsIdEditRoute: SportsIdEditRoute,
}

const SportsRouteWithChildren =
  SportsRoute._addFileChildren(SportsRouteChildren)

interface UsersRouteChildren {
  UsersIndexRoute: typeof UsersIndexRoute
}

const UsersRouteChildren: UsersRouteChildren = {
  UsersIndexRoute: UsersIndexRoute,
}

const UsersRouteWithChildren = UsersRoute._addFileChildren(UsersRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AssetsRoute: AssetsRoute,
  CatalogueRoute: CatalogueRoute,
  ChangePasswordRoute: ChangePasswordRoute,
  ConfigurationRoute: ConfigurationRouteWithChildren,
  ContestsRoute: ContestsRouteWithChildren,
  LoginRoute: LoginRoute,
  OperationsRoute: OperationsRoute,
  PrizeTierDefaultsRoute: PrizeTierDefaultsRouteWithChildren,
  QaSeedRoute: QaSeedRoute,
  SportsRoute: SportsRouteWithChildren,
  UsersRoute: UsersRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
